module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Selected-file-56604a6eeb63b93c477342b78f67ef02.svg";